import { useState } from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errorMessage } from "@/lib/api";
import { CodeInput, ResendButton } from "@/components/CodeInput";

export default function TwoFactor() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { completeTwoFactor } = useAuth();
  const [code, setCode] = useState("");
  const [recovery, setRecovery] = useState("");
  const [useRecovery, setUseRecovery] = useState(false);
  const [remember, setRemember] = useState(true);
  const [busy, setBusy] = useState(false);
  if (!state?.challenge) return <Navigate to="/entrar" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await completeTwoFactor(state.challenge, useRecovery ? recovery.trim() : code, remember);
      navigate("/inicio", { replace: true });
    } catch (err) { toast.error(errorMessage(err)); setCode(""); } finally { setBusy(false); }
  };
  const resend = async () => { try { await api.post("/auth/2fa/resend", { challenge: state.challenge }); toast.success("Novo código enviado."); } catch (err) { toast.error(errorMessage(err)); } };

  return (
    <div className="ga-fade-up mx-auto flex min-h-screen max-w-sm flex-col justify-center px-6 py-10" data-testid="two-factor-page">
      <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl" style={{ background: "#05324A", color: "#33D9B2" }}><ShieldCheck size={28} /></div>
      <h1 className="text-2xl font-bold">Verificação em duas etapas</h1>
      <p className="ga-muted mt-2 text-sm">{state.email_sent === false ? <>Não conseguimos enviar o código para <b data-testid="two-factor-hint">{state.hint}</b>. Tente reenviar ou use um código de recuperação.</> : <>Enviamos um código de 6 dígitos para <b data-testid="two-factor-hint">{state.hint}</b>.</>}</p>
      <form onSubmit={submit} className="mt-6 space-y-3">
        {useRecovery
          ? <input value={recovery} onChange={(e) => setRecovery(e.target.value.toUpperCase())} placeholder="XXXX-XXXX" className="ga-input w-full text-center text-xl tracking-widest" aria-label="Código de recuperação" data-testid="two-factor-recovery-input" />
          : <CodeInput value={code} onChange={setCode} testId="two-factor-code" />}
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} data-testid="two-factor-remember" /> Confiar neste dispositivo por 30 dias</label>
        <button type="submit" disabled={busy || (useRecovery ? recovery.length < 8 : code.length !== 6)} className="ga-btn-primary w-full" data-testid="two-factor-submit">{busy ? "Verificando..." : "Entrar"}</button>
        {!useRecovery && <ResendButton onResend={resend} testId="two-factor-resend" />}
      </form>
      <button onClick={() => setUseRecovery(!useRecovery)} className="ga-muted mt-6 text-center text-xs underline" data-testid="two-factor-toggle-recovery">{useRecovery ? "Usar código enviado por e-mail" : "Sem acesso ao e-mail? Usar código de recuperação"}</button>
      <button onClick={() => navigate("/entrar")} className="ga-muted mt-3 text-center text-xs" data-testid="two-factor-back">Voltar</button>
    </div>
  );
}
